<template>
     <div class="tenant-search">
          <PageTitle icon="fa fa-clone" main="Record" sub="Tenant" />
            <b-form v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input id="tenant-id" type="hidden" v-model="tenant.id" />
             <b-row>
                <b-col md="5" sm="12">
                    <b-form-group 
                        label="Name:" 
                        label-for="tenant-name_tenant">
                        <b-form-input 
                            id="tenant-name_tenant" 
                            type="text" 
                            ref="searchFocus"
                            v-model="tenant.name_tenant" 
                            required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Name..." />
                    </b-form-group>
                </b-col>   
                <b-col md="3" sm="12">
                    <b-form-group 
                        label="ID:" 
                        label-for="tenant-doc_identification_tenant">    
                        <b-form-input
                            id="tenant-doc_identification_tenant" 
                            type="text"
                            v-model="tenant.doc_identification_tenant" 
                            required
                            size="sm"
                            :readonly="true"
                            placeholder="ID..." />  
                    </b-form-group>
                </b-col>
                <b-col md="1" sm="12">
                    <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="tenant.blocked_tenant" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="tenant-blocked_tenant"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            >
                            <label class="form-check-label" for="tenant-blocked_tenant">
                                Blocked?
                            </label>
                        </div>
                    </div>
                </b-col>  
              
             </b-row>
            <b-card class="owner-search-card">
                    <b-tabs card >
                        <b-tab title="Complementary" active>
                        <b-form>
                             <b-row>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Nationality:" 
                                        label-for="tenant-nationality_tenant">
                                        <b-form-input 
                                            id="tenant-nationality_tenant" 
                                            type="text"
                                            v-model="tenant.nationality_tenant" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Nationality" />
                                    </b-form-group>
                                </b-col>
                                 <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Passport:" 
                                        label-for="tenant-passport_tenant">
                                        <b-form-input 
                                            id="tenant-passport_tenant" 
                                            type="text"
                                            v-model="tenant.passport_tenant" 
                                              size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Passport" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="6" sm="12">
                                    <b-form-group
                                        label="Gender:"
                                        label-for="tenant-gender_tenant"
                                    >
                                        <b-form-select
                                            id="tenant-gender_tenant"
                                            size="sm"
                                            :options="gendertenants"
                                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            v-model="tenant.gender_tenant"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                 <b-col md="2" sm="12">
                                    <b-form-group
                                    label="Birth Date:"
                                    label-for="tenant-birth_date_tenant"
                                    >
                                    <b-form-input
                                    id="tenant-birth_date_tenant"
                                    type="date"
                                    v-model="tenant.birth_date_tenant"
                                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                    size="sm"
                                    />
                                    </b-form-group>
                                </b-col>
                              
                            </b-row>
                            
                        </b-form>
                    </b-tab >
                    <b-tab title="Contact">
                        <b-form>
                            <b-row>
                                 <b-col md="6" sm="12">
                                    <b-form-group 
                                        label="E-mail:" 
                                        label-for="tenant-email_tenant">
                                        <b-form-input 
                                        id="tenant-email" 
                                        type="email"
                                        v-model="tenant.email_tenant" 
                                        size="sm"
                                        :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                        placeholder="E-mail" />
                                    </b-form-group>
                                </b-col>
                                <b-col md="3" sm="12">
                                    <b-form-group 
                                        label="Phone number:" 
                                        label-for="tenant-cellphone_tenant">
                                        <b-form-input 
                                            id="tenant-cellphone_tenant" 
                                            type="text"
                                            v-model="tenant.cellphone_tenant" 
                                            size="sm"
                                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                            placeholder="Phone number" />
                                    </b-form-group>
                                </b-col>
                               
                            </b-row>  
                            <b-row>
                                  <b-col  md="12" sm="12">

                                <b-row>
                                    <b-button v-show="!showFile" class="mb-2 ml-3 fa fa-plus"  title="Add Image" squared variant="outline-dark" @click="showFile = true"></b-button>
                                    <b-button v-show="!showFile" class="mb-2 ml-2 fa fa-trash"  title="Delete Image" squared variant="outline-dark" ></b-button>
                                    <b-button v-show="!showFile" class="mb-2 ml-2 fa fa-file-pdf-o"  title="View File" squared variant="outline-dark" @click="loadUrl(tenant)"></b-button>
                                </b-row>
                                <b-img v-bind="{width: 200, height: 200}" thumbnail fluid :src="tenant.url_file" alt="Responsive image"></b-img>
                                <b-row>
                                    <b-col  md="6" sm="12">
                                        <b-form-file accept=".jpg, .png, .gif"  @input="saveImagem" v-show="showFile" v-model="file" class="mt-3" plain></b-form-file>
                                    </b-col>    
                                    <!--b-col  md="1" sm="12">
                                        <b-button  
                                            title="Salvar" 
                                            size="sm" 
                                            class="mb-2 mt-2 fa fa-save" 
                                            variant="light" 
                                            v-show="showFile"
                                            @click="save">
                                        </b-button>
                                    </b-col-->
                                    <b-col  md="1" sm="12">
                                        <b-button  
                                            title="Back" 
                                            size="sm" 
                                            class="mb-2 mt-2 fa fa-close" 
                                            variant="drak" 
                                            v-show="showFile"
                                            @click="showFile = false">
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-col>
                            </b-row> 
                        </b-form>
                        </b-tab>
                        <b-tab title="Signed Agreement"> 
                        <b-row>
                        <transition  name="slide" type="animation" appear>       
                        <b-table 
                            class="table-responsive" 
                            hover 
                            key="slide"  
                            head-variant="light" 
                            :items="tenantagreements" 
                            :fields="fieldAgreement">
                            <template v-slot:cell(actions)="data">
                                <b-button 
                                    title="Reference Letter" 
                                    size="sm" 
                                    variant="light" 
                                    @click="[printerReferenceLetter(data.item)]" 
                                    class="mr-2 mt-2">
                                    <i class="fa fa-file-pdf-o"></i>
                                </b-button>
                            </template>
                        </b-table>
                        </transition>  
                        </b-row>
                        
                        </b-tab>
                    </b-tabs>
                </b-card>
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadTenants(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                            v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by tenant name" 
                            class="form-control">
                    </div>
                </div>  
                <b-row>
                <b-col md="12" sm="12">
                            <b-form-group 
                                label="Situation">
                            <b-form-radio-group
                                size="lg"
                                v-model="receipt"
                                @input="loadTenants"
                                :options="optionsReceipt"
                                name="tenant-receipt"
                            ></b-form-radio-group>  
                            </b-form-group>    
                        </b-col>
                </b-row>
          <transition  name="slide" type="animation" appear>       
            <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                 <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                   <b-dropdown id="dropdown-form-offset" size="sm"    text="..." ref="dropdown" variant="outline-info" class="mr-2 mt-2">
                    <b-button
                        v-if="!data.item.tenant_user_id_tenant >0"  
                        title = "Create Login" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCreateUser(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-user-circle"></i>
                    </b-button>
                     <b-button
                        v-if="data.item.tenant_user_id_tenant >0"  
                        title = "Send Mail Login" 
                        size="sm" 
                        variant="light" 
                        @click="sendMailLoginTenant(data.item.id)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-envelope-o"></i>
                    </b-button>
                   
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadTenant(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                    <b-button
                        title = "Attachment Passport"
                        size="sm"
                        @click="setPassport(data.item)"
                        variant="light"
                        class="mr-2 mt-2 fa fa-plus"
                        v-b-modal.modalFile
                        > 
                    </b-button>
                    <b-button
                        title="View File"
                        size="sm"
                        variant="light"
                        v-if="data.item.storage_id_passport_tenant > 0"
                        @click="loadUrl(data.item)"
                        class="mr-2 mt-2"
                    >
                    <i class="fa fa-file-pdf-o"></i>
                    </b-button>
                     <b-button 
                        size="sm"
                        v-show="!showEnvioEmail && data.item.tenant_user_id_tenant > 0" 
                        class="ml-2 mt-2 " :variant="data.item.send_login_tenant? 'success' :'info'" disabled>
                        {{data.item.send_login_tenant? 'Sent' : 'Not sent'}} 
                    </b-button>
                   </b-dropdown>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
    </b-row>
     <b-modal
            id="modalAgreement"
            ref="modal"
            title-tag="h6"
            title="Agreement"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveAgreement"
        >
            <b-form>
                <b-row>
                      <b-col md="2" sm="12">
                            <b-form-group
                            label="Agreement Date:"
                            label-for="tenantagreement-agreement_date"
                            >
                            <b-form-input
                            id="tenantagreement-agreement_date"
                            type="date"
                            v-model="tenantagreement.agreement_date"
                            size="sm"
                            />
                            </b-form-group>
                        </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                        <b-form-group
                            label="Agreement Name:"
                            label-for="tenantagreement-bank_name_tenant"
                        >
                            <b-form-input
                                id="tenantagreement-bank_name_tenant"
                                v-model="tenantagreement.bank_name_tenant"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col md="6" sm="12">
                        <b-form-group
                            label="BCI:"
                            label-for="tenantagreement-bic_tenant_bank"
                        >
                            <b-form-input
                                id="tenantagreement-bic_tenant_bank"
                                v-model="tenantagreement.bic_tenant_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="IBAN:"
                            label-for="tenantagreement-iban_tenant_bank"
                        >
                            <b-form-input
                                id="tenantagreement-iban_tenant_bank"
                                v-model="tenantagreement.iban_tenant_bank"
                                type="text"
                                size="sm"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                <b-col md="1" sm="12">
                    <div class="form-group">
                    <div class="form-check">
                        <input class="form-check-input" 
                            v-model="tenantagreement.favorite_tenant_bank" 
                            true-value="1" false-value="0" 
                            type="checkbox" 
                            id="tenantagreement-favorite_tenant_bank"
                        >
                        <label 
                            class="form-check-label" 
                            for="tenantagreement-favorite_tenant_bank">
                            Favorite?
                        </label>
                    </div>
                    </div>
                </b-col>  
            
                </b-row>
            </b-form>
        </b-modal>
         <b-modal
            id="modalImmobile"
            ref="modal"
            title-tag="h6"
            title="Immobile"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="saveImmobile"
        >
          <b-form>
                <b-row>
                    <b-col md="12" sm="12">
                    <b-form-group 
                            label="Address:" 
                            label-for="immobile-address_immobile">
                        <b-form-input id="immobile-address_immobile" 
                            type="text"
                            v-model="immobile.address_immobile" 
                            size="sm"
                            placeholder="Address..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="12" sm="12">
                    <b-form-group 
                            label="Region:" 
                            label-for="immobile-region_immobile">
                        <b-form-input id="immobile-region_immobile" 
                            type="text"
                            v-model="immobile.region_immobile" 
                            size="sm"
                            placeholder="Region..." />
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="6" sm="12">
                        <b-form-group
                            label="Type:"
                            label-for="immobile-type_immobile_id_immobile"
                        >
                            <b-form-select
                                id="immobile-type_immobile_id_immobile"
                                size="sm"
                                :options="gendertenants"
                                v-model="immobile.type_immobile_id_immobile"
                            />
                        </b-form-group>
                    </b-col>
                <b-col md="4" sm="12">
                    <b-form-group
                        label="Maximum Tenant:"
                        label-for="immobile-maximum_number_tenant_immobile"
                    >
                        <b-form-input
                            id="immobile-maximum_number_tenant_immobile"
                            type="number"
                            v-model="immobile.maximum_number_tenant_immobile"
                            size="sm"
                        />
                    </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                    <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.active_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-active_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-active_immobile">
                                Active?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                     <b-col md="2" sm="12">
                        <div class="form-group">
                        <div class="form-check">
                            <input class="form-check-input" 
                                v-model="immobile.blocked_immobile" 
                                true-value="1" false-value="0" 
                                type="checkbox" 
                                id="immobile-blocked_immobile"
                            >
                            <label 
                                class="form-check-label" 
                                for="immobile-blocked_immobile">
                                Blocked?
                            </label>
                        </div>
                        </div>
                    </b-col>  
                </b-row>
          </b-form>
        </b-modal>
        <b-modal
         id="modalFile"
            ref="modal"
            title-tag="h6"
            size="lg"
            title="File"
            :header-bg-variant="headerBgVariant"
            :header-text-variant="headerTextVariant"
            :body-bg-variant="bodyBgVariant"
            :body-text-variant="bodyTextVariant"
            @ok="save"
      >
        <b-form>
          <b-row>
            <b-col md="12" sm="12">
              <b-form-file
                accept=".pdf, .jpeg, .jpg, .png"
                v-model="file"
                placeholder="Choose a file or drop it here..."
                drop-placeholder="Drop file here..."
                @input="saveImagem"
                size="sm"
              ></b-form-file>
            </b-col>
          </b-row>
        </b-form>
      </b-modal>  
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'TenantSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                url_file: '',
                receipt:null,
                file:null,
                tenant: {},
                tenantagreement: {},
                immobile: {},
                tenantagreements:[],
                immobiles:[],
                tenants: [],
                gendertenants: [],
                perPage: 50,
                currentPage: 1,
                isBusy: false,
                showTable: false,
                showFile: false,
                showEnvioEmail: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                { key: 'name_tenant', label: 'Name', sortable: true,variant: 'light' },
                { key: 'doc_identification_tenant', label: 'ID', sortable: true ,variant: 'light'},
                { key: 'nationality_tenant', label: 'Nationality', sortable: false ,variant: 'light'},   
                { key: 'email_tenant', label: 'E-mail', sortable: false ,variant: 'light'},   
                { key: 'cellphone_tenant', label: 'Phone Number', sortable: false ,variant: 'light'},   
                {
                        key: 'birth_date_tenant',label: 'Birth Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('DD-MM-YYYY') : '',variant: 'light'
                },
                { key: 'blocked_tenant', label: 'Blocked', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' ,variant: 'light'},               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
                fieldAgreement: [
                {
                    key: 'agreement_date',label: 'Agreement Date',sortable: true,
                        formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'exist_contract_agreement', label: 'Exists Contract', sortable: false,
                        formatter: value => value ? 'Yes' : 'No' },
                { key: 'address_immobile', label: 'Address', sortable: true },
                { key: 'region_immobile', label: 'Region', sortable: false },
                { key: 'name_type_part_immobile', label: 'Object', sortable: true },
                { key: 'name_owner', label: 'Landlord', sortable: false },
                {
                    key: 'contract_value_agreement',
                    label: 'Contract Value',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                {
                    key: 'deposit_amount_agreement',
                    label: 'Deposit Amount',
                    sortable: false,
                    variant: 'secondary',
                    formatter: value => (value ? this.formatPrice(value) : 0)
                },
                { key: 'contract_months_agreement', label: 'Months Contratct', sortable: false },

                {
                    key: 'closing_date_agreement',label: 'Closing Date',sortable: true,
                    formatter: value =>
                        value ? moment.utc(value).format('DD-MM-YYYY') : ''
                },
                { key: 'actions', label: 'Action',variant: 'light' }
                ],
                optionsReceipt: [
                        { text: 'Birthdays', value: 1 },
                        { text: 'Birthdays of the Month', value: 2 },
                        { text: 'Next month Birthdays', value: 3 },
                        { text: 'All', value: null }     
                ],
            }
        },
        computed: {
            filteredList() {
                return this.tenants.filter(tenant => {
                    return tenant.name_tenant.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.tenants.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
            formatDate(date) {
                return moment(date)
                    .format('YYYY-MM-DD')
                    
            },
            formatDateTime(date) {
                return moment(date)
                    .format('YYYY-MM-DD LT')
            },
            formatPrice(value) {
                let val = (value / 1).toFixed(2).replace('.', ',')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
               async showMsgBoxCreateUser(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to create login?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.createUserTenant(item)
                    }
                })
            },
            async showMsgBoxDeleteAgreement(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeAgreement(item)
                    }
                })
            },
             async showMsgBoxDeleteImmobile() {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to delete the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.removeImmobile()
                    }
                })
            },
            loadTenants(){
                const url = `${baseApiUrl}/tenentsbycompany/${this.compan.id}/?only_birthdays=${this.receipt}`
                axios(url).then(res =>{
                     this.tenants = res.data
                      this.isBusy = false
                })
            },
            loadTenantAgreements(){
                const url = `${baseApiUrl}/tenantagreementbytenant/${this.tenant.id}`
                axios(url).then(res =>{
                     this.tenantagreements = res.data
                })
            },
            loadTenantImmobiles(){
                const url = `${baseApiUrl}/tenantagreementbytenant/${this.tenant.id}`
                axios(url).then(res =>{
                     this.immobiles = res.data
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.tenant = {}
                    this.tenantagreement = {}
                    this.immobile = {}
                    this.tenantagreements = []
                    this.immobiles = []
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadTenants()
                this.tenantagreements = []
                this.immobiles = []
                this.tenant = {}
            },
            async save() {

                const method = this.tenant.id ? 'put' : 'post'
                const id = this.tenant.id ? `/${this.tenant.id}` : ''

                if(this.tenant.id){
                    this.tenant.update_date_tenant = this.formatDateTime(Date())
                    this.tenant.update_user_id_tenant = this.user.id
                }else{
                    this.tenant.user_id_tenant = this.user.id
                    this.tenant.company_id_tenant = this.compan.id
                }

                await axios[method](`${baseApiUrl}/tenants${id}`, this.tenant)
                    .then(async () => {
                        this.$toasted.global.defaultSuccess()
                        await this.createEntity(this.tenant)
                        this.reset()
                    })
                    .catch(showError)
            },
            async createEntity(item){
                 await axios['post'](`${baseApiUrl}/tenentscreateentity`, item)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()

                    })
                    .catch(showError)
            },
            async saveAgreement() {
                    if (this.tenantagreement.id) {
                        this.tenantagreement.update_user_tenant_bank = this.user.id
                        this.tenantagreement.update_date_tenant_bank = this.formatDateTime(Date())
                    } else {
                        this.tenantagreement.user_id_tenant_bank = this.user.id
                    }

                    const method = this.tenantagreement.id ? 'put' : 'post'
                    const id = this.tenantagreement.id ? `/${this.tenantagreement.id}` : ''
                    this.tenantagreement.tenant_bank_id = this.tenant.id
                    await axios[method](
                        `${baseApiUrl}/tenantagreements${id}`,
                        this.tenantagreement
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.tenantagreement = {}
                            this.loadTenantAgreements()
                        })
                        .catch(showError)
            },
            async saveImmobile() {

                    if (this.immobile.id) {
                        this.immobile.update_user_immobile = this.user.id
                        this.immobile.update_date_immobile = this.formatDateTime(Date())
                    } else {
                        this.immobile.user_id_immobile = this.user.id
                    }

                    const method = this.immobile.id ? 'put' : 'post'
                    const id = this.immobile.id ? `/${this.immobile.id}` : ''
                    this.immobile.tenant_id_immobile = this.tenant.id
                    await axios[method](
                        `${baseApiUrl}/immobiles${id}`,
                        this.immobile
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.immobile = {}
                            this.loadTenantImmobiles()
                        })
                        .catch(showError)
            },
            remove() {
                    const id = this.tenant.id
                    axios.delete(`${baseApiUrl}/tenants/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
           async removeAgreement(item) {
 
                    axios.delete(`${baseApiUrl}/tenantagreements/${item.id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTenantAgreements()
                        })
                        .catch(showError)
            },
           async removeImmobile() {
                    const id = this.tenant.id
                    axios.delete(`${baseApiUrl}/immobiles/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadTenantImmobiles()
                        })
                        .catch(showError)
            },

            loadTenant(tenant, mode = 'save') {
                this.mode = mode

                  if (tenant.birth_date_tenant)
                tenant.birth_date_tenant = this.formatDate(
                    tenant.birth_date_tenant
                )

                this.tenant = { ...tenant }
                this.$refs.searchFocus.focus();
                this.loadTenantAgreements()
                this.loadTenantImmobiles()
            },
            loadTenantAgreement(item){
                this.tenantagreement = {...item}
            },
            loadTenantImmobile(item){
                this.immobile = {...item}
            },
            openModalAgreement() {
                this.$bvModal.show('modalAgreement')
            },
            openModalImmobile() {
                this.$bvModal.show('modalImmobile')
            },
            loadGenderTenant() {
                const url = `${baseApiUrl}/gendertenants`
                axios.get(url).then(res => {
                    this.gendertenants = res.data.map(type => {
                        return { value: type.id, text: type.name_gender_tenant }
                    })
                })
            },
            async printerReferenceLetter(item) {
    
            const url = `${baseApiUrl}/tenantreferenceletterprinter/${item.id}`
            await axios.get(url)
            window.open(url)
            
            },
            setPassport(tenant){
                 this.tenant = { ...tenant }
            },
              async saveImagem() {
                let formData = new FormData();
                formData.append("file", this.file);

                await axios
                    .post(`${baseApiUrl}/storagefiles`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    })
                    .then(() => {
                    this.$toasted.global.defaultSuccess();
                    this.getLastStorageFile();
                    })
                    .catch(showError);
                },
                async getLastStorageFile() {
                const url = `${baseApiUrl}/storagefilesbylast/?name_file=${this.file.name}`;
                    await axios(url).then(
                        (res) =>
                        (
                            this.tenant = {
                            ...this.tenant,
                            storage_id_passport_tenant: res.data.id,
                            url_file: res.data.url_file
                             }
                        )

                    );
                },  
                loadUrl(item){
                    window.open(item.url_file)
                }, 
                async createMailLoginTenant(id){

                    await axios.post(`${baseApiUrl}/createmaillogintenants/${id}`)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                this.getLastUserTenant()
                              //  this.sendMailLoginTenant(id)
                            })
                            .catch(showError)
                },
                 async sendMailLoginTenant(id){
                       this.showEnvioEmail = true

                     await axios.post(`${baseApiUrl}/sendmaillogintenants/${id}`)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                  this.showEnvioEmail = false
                                  this.loadTenants()
                            })
                            .catch(showError)
                             this.showEnvioEmail = false
                 },
                async createUserTenant(item){

                        this.tenant = {...item}
                       if (!item.email_tenant) {
                            this.$toasted.global.defaultError({ msg: 'Email not provided when registering..' })
                        }
                        if (!item.birth_date_tenant) {
                            this.$toasted.global.defaultError({ msg: 'Date of birth not specified in registration...' })
                        }

                        let user_tenant = {}

                        user_tenant = {

                            name: item.name_tenant,
                            email: item.email_tenant,
                            company_default_id: this.compan.id,
                            blocked: 0,
                            tenant:1,
                            password: moment(item.birth_date_tenant).format('YYYY'),
                            confirmPassword: moment(item.birth_date_tenant).format('YYYY')
                        }

                         axios.post(`${baseApiUrl}/signup`, user_tenant)
                            .then(() => {
                                this.$toasted.global.defaultSuccess()
                                this.createMailLoginTenant(item.id)
                            })
                            .catch(showError)
                },
                async getLastUserTenant() {
                const url = `${baseApiUrl}/tenantbyuserid/${this.compan.id}/?name=${this.tenant.name_tenant}&email=${this.tenant.email_tenant}`;
                    await axios(url).then(
                        (res) =>
                        (this.tenant = {
                            ...this.tenant,
                            tenant_user_id_tenant: res.data.id,
                        })
                    );

                    if(this.tenant.tenant_user_id_tenant > 0){
                        this.save()
                    }
                },  

        },
        mounted(){
            this.loadTenants()
            this.loadGenderTenant()
            this.showTable = true
        }
}
</script>

<style>


    .tenant-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .tenant-search button{
        font-size: 0.75rem;
    }

     .tenant-search select{
        font-size: 0.75rem;
    }

    .tenant-search input{
        font-size: 0.75rem;
    }


    .tenant-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }


    #modalAgreement {
        font-size: 0.75rem;
    }

    #modalAgreement button{
        font-size: 0.75rem;
    }

     #modalAgreement input{
        font-size: 0.75rem;
    }

      #modalAgreement label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }

    #modalFile {
    font-size: 0.75rem;
    }

    #modalFile button{
    font-size: 0.75rem;
    }



    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
